export function computeMaxListingOrder(items: { listingOrder?: number }[] | undefined): number {
	if (!items) return 0;

	return items.reduce((max, item) => Math.max(max, item.listingOrder || 0), 0);
}
